
import React from "react";
import { FormProvider, useForm } from 'react-hook-form'

export const OverViewDatePicker = ({ getRange }) => {
  const method = useForm({ mode: 'all', })
  return (
    <FormProvider {...method}>
      {/* <DateRange name="date_range" className={`w-[200px] `} getRange={getRange} /> */}
     
    </FormProvider>
  );
};